import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  Pagination,
  PagingResponseModel,
} from "../../shared";
import { Observable } from "rxjs";
import { FilesDetailsRequest } from "../../../../../../models/file-image";
import { Optional } from "typescript-optional";

@Injectable({
  providedIn: "root",
})
export class BudgetGenericDocAttachmentService extends BaseApiTemplateService<any> {
  readonly url =
    Core2Config.DOMAIN_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX +
    Core2Config.GENERIC_PREFIX +
    "budget-gen-doc_attachments";

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "budget-gen-doc_attachments";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      "budget-gen-doc_attachments";
    this.httpClient = http;
  }

  public addAttachment(
    hdrGuid: string,
    files: File[],
    visa: ApiVisa,
    filesDetails?: FilesDetailsRequest
  ) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const formData: FormData = new FormData();
    files.forEach((file) => formData.append("files", file));
    if (filesDetails) {
      formData.set(
        "files-data",
        new Blob([JSON.stringify(filesDetails)], { type: "application/json" }),
        "files-data.json"
      );
    }

    return this.httpClient.put<ApiResponseModel<any>>(
      this.apiUrl + "/add-files/backoffice-ep/" + hdrGuid,
      formData,
      this.getHttpHeader(visa)
    );
  }

  public updateAttachment(
    attachmentGuid: string,
    file: File,
    visa: ApiVisa,
    filesDetails: Optional<FilesDetailsRequest>
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const formData: FormData = new FormData();
    if (file) {
      formData.append("files", file);
      filesDetails.ifPresent((details) =>
        formData.set(
          "file-data",
          new Blob([JSON.stringify(details)], { type: "application/json" }),
          "file-data.json"
        )
      );
    }

    return this.httpClient.put<ApiResponseModel<any>>(
      this.apiUrl + "/replace-file/backoffice-ep/" + attachmentGuid,
      formData,
      this.getHttpHeader(visa)
    );
  }

  public deleteAttachment(
    attachmentGuid: string,
    visa: ApiVisa
  ): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<any>>(
      this.apiUrl + "/backoffice-ep/" + attachmentGuid,
      this.getHttpHeader(visa)
    );
  }

  // the actual file
  public getAttachmentFile(
    attachmentGuid: string,
    apiVisa: ApiVisa
  ): Observable<Blob> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<Blob>(
      this.apiUrl + "/file/backoffice-ep/" + attachmentGuid,
      this.getHttpHeaderBlob(apiVisa)
    );
  }

  // the json of all budget-gen-doc_attachments
  public getAllAttachments(visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<ApiResponseModel<any>>(
      this.apiUrl + "/backoffice-ep/",
      this.getHttpHeader(visa)
    );
  }

  public getAttachmentByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any
  ): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + "/backoffice-ep/query?" + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public addLineItemAttachment(
    lineGuid: string,
    files: File[],
    visa: ApiVisa,
    filesDetails?: FilesDetailsRequest
  ) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    const formData: FormData = new FormData();
    files.forEach((file) => formData.append("file", file));
    if (filesDetails) {
      formData.set(
        "files-data",
        new Blob([JSON.stringify(filesDetails)], { type: "application/json" }),
        "files-data.json"
      );
    }

    return this.httpClient.put<ApiResponseModel<any>>(
      this.apiUrl + "/add-files/backoffice-ep/gen-doc-line/" + lineGuid,
      formData,
      this.getHttpHeader(visa)
    );
  }
}
